<script setup lang="ts">

import { RequestState } from "../services/BaseService.ts";
import BasicLoader from "@/components/basic/BasicLoader.vue";

type IProps = {
  stateRef: RequestState
}

const props = defineProps<IProps>();

</script>

<template>
  <div class="w-full h-full relative">
    <slot />
    <BasicLoader :show="props.stateRef === RequestState.Loading" />
  </div>
</template>

<style scoped lang="scss">

</style>
